import type { WidgetMapper } from 'ui/containers/ContentBuilder';
import { loadable } from 'ui/utilities';

const boletoView = loadable(
  () =>
    import(/* webpackChunkName: "container-order-success-boleto-in-cash" */ './OrderSuccessBoleto'),
);

const orderinfo = loadable(
  () => import(/* webpackChunkName: "container-order-success-info" */ './OrderSuccessInfo'),
);

const ordercta = loadable(
  () => import(/* webpackChunkName: "container-order-success-cta" */ './OrderSuccessCta'),
);

const shippingmodelpickupstore = loadable(
  () =>
    import(
      /* webpackChunkName: "container-order-success-shipping-model-pickup-store" */ './ShippingModelPickupStore'
    ),
);

export const orderSuccessGenericWidgetsMapper: WidgetMapper = {
  boletogeneric: loadable(
    () =>
      import(
        /* webpackChunkName: "container-order-success--boleto-generic" */ './OrderSuccessGeneric'
      ),
  ),
  ordercta,
};

export const orderSuccessBoletoWidgetsMapper: WidgetMapper = {
  boletoincash: boletoView,
  ordercta,
  orderinfo,
  shippingmodelpickupstore,
};

export const orderSuccessBoletoInstallmentsWidgetsMapper: WidgetMapper = {
  boletoontime: boletoView,
  ordercta,
  orderinfo,
  shippingmodelpickupstore,
};
